export const capitalize = (text) => {
    if (text && text.length > 0) {
        return text.charAt(0).toUpperCase() + text.slice(1);
    }
    return '';
};
export const capitalizeFirstLetter = (text) => {
    if (!text || text.length === 0) {
        return '';
    }
    return text.charAt(0).toUpperCase() + text.slice(1);
};
//# sourceMappingURL=string.js.map